import * as actionTypes from '../actions/actionTypes';
import { stateType } from '../../components/commonConfig.json'

const initialState = {
    error: null,
    loading: false,
    userHotelsData: [],
    envelopResendState: {
        stateShow: false,
        stateType:stateType.SUCCESS,
        stateMessage: ''
    }
}

const signatureAppApi = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESEND_ENVELOP_TO_NOT_SIGNED_SUCCESS:
            return {
                ...state,
                envelopResendState: {
                    stateShow : true,
                    stateType:stateType.SUCCESS,
                    stateMessage:action.data
                }
            }
        case actionTypes.RESEND_ENVELOP_TO_NOT_SIGNED_FAILED:
            return {
                ...state,
                envelopResendState: {
                    stateShow : true,
                    stateType:stateType.ERROR,
                    stateMessage:action.data
                }
            }
        case actionTypes.CLEAR_RESEND_STATE:
            return {
                ...state,
                envelopResendState: {
                    stateShow : false,
                    stateType:stateType.SUCCESS,
                    stateMessage:''
                }
            }
        default:
            return state;
    }
}

export default signatureAppApi;